export enum UserRoleType {
  GlobalAdministrator = "GlobalAdministrator",
  Administrator = "Administrator",
  GrowthCoach = "GrowthCoach",
  Creative = "Creative",
}
